<template>
  <el-dialog :visible.sync="visible"
             :title="dataForm.orgId ? '编辑部门' : '新建部门'">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
      <el-form-item prop="orgName" :label="$t('dept.name')">
        <el-input v-model="dataForm.orgName" :placeholder="$t('dept.name')" :maxlength="20"></el-input>
      </el-form-item>
      <el-form-item prop="orgName" :label="$t('dept.name')" v-show="false">
        <el-input v-model="dataForm.orgName" :placeholder="$t('dept.name')"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dataFormSubmitHandle()">确 定</el-button>
      <el-button @click="visible = false">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        orgId: '',
        orgName: '',
        parentId: 0,
        orgSort: 0
      }
    }
  },
  computed: {
    dataRule () {
      return {
        orgName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        let params = {
          orgId: this.dataForm.orgId,
          orgName: this.dataForm.orgName
        }
        this.$http.post(`/front/consumer/custorg/${this.dataForm.orgId ? 'updateCustSysOrg' : 'saveCustSysOrg'}`,
          this.dataForm.orgId ? params : this.dataForm
        )
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
              // this.$message.error(res.msg)
            }
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.visible = false
                this.$emit('refreshDataList')
              }
            })
          }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
<style lang='scss' scoped>
</style>
